import styled, { css, keyframes } from 'styled-components';
export const LinearProgressWrapper = styled.div`
  color: ${props => {
  switch (props.color) {
    case 'primary':
      return '#3f51b5';

    case 'secondary':
      return '#f50057';

    case 'inherit':
      return 'inherit';
  }
}};
  height: 4px;
  overflow: hidden;
  position: relative;
  background: ${props => {
  switch (props.color) {
    case 'primary':
      return 'rgb(182, 188, 226)';

    case 'secondary':
      return 'rgb(251, 158, 191)';

    case 'inherit':
      return 'inherit';
  }
}};
`;
const LinearBar = css`
  top: 0;
  left: 0;
  bottom: 0;
  position: absolute;
  transition: transform 0.2s linear;
  transform-origin: left;
  background: currentColor;
`;
const keyframesExpandBar = keyframes`
0% { left: -35%; width: 35%; }
60% { left: 100%; width: 90%;}
100% { left: 100%; width: 90%;}
`;
export const LinearExpandBar = styled.div`
  width: auto;
  animation: ${keyframesExpandBar} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395)
    infinite;
  ${LinearBar}
`;
const keyframesShrinkBar = keyframes`
0% { left: -200%; width: 200%; }
60% { left: 107%; width: 1%;}
100% { left: 107%; width: 1%;}
`;
export const LinearShrinkBar = styled.div`
  width: auto;
  animation: ${keyframesShrinkBar} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s
    infinite;
  ${LinearBar}
`;